export const navigationLinks = [
  { label: '首页', href: '#hero' },
  { label: '精彩片段', href: '#media' },
  { label: '最新动态', href: '#updates' },
  { label: '关于我们', href: '#about' },
  { label: '观众口碑', href: '#comments' },
];

export const heroData = {
  tagLabel: '高清免费 · 流畅不缓冲',
  title: '天狼影院',
  subtitle: '电视剧全集连播平台',
  description: '天狼影院致力于为广大追剧爱好者提供最新、最全的电视剧全集连播服务。平台汇聚海量高清剧集资源，涵盖国产剧、韩剧、美剧、日剧、泰剧等多元化内容，每日实时更新，确保用户第一时间观看到最新剧集。采用先进的视频编码与CDN加速技术，实现流畅不缓冲的观影体验，无论手机还是电脑，都能畅享高清画质。无论您是追热播大剧，还是重温经典老片，天狼影院都是您的最佳选择。',
  stats: [
    { label: '覆盖剧集', value: '50,000+' },
    { label: '每日更新', value: '200+' },
    { label: '高清画质', value: '1080P+' },
  ],
  primaryCta: { label: '开始追剧', href: '#cards' },
  secondaryCta: { label: '查看榜单', href: '#ranking' },
};

export const appSectionData = {
  title: '移动追剧',
  subtitle: '随时随地，畅享高清',
  description: '天狼影院移动版适配手机与平板，支持横竖屏切换，流畅播放不卡顿。下载APP还可离线缓存，无网络也能追剧。',
  features: ['高清画质', '离线缓存', '投屏播放', '弹幕互动'],
  ctaLabel: '下载天狼影院APP',
  ctaHref: '#contact',
};

export const faqData = [
  {
    question: '天狼影院的电视剧资源是否免费？',
    answer: '是的，天狼影院所有电视剧资源均免费提供高清在线观看。用户无需注册会员、无需付费，即可畅享海量剧集内容。我们通过广告支持运营，确保用户获得零门槛的追剧体验。',
  },
  {
    question: '为什么播放时偶尔会出现缓冲？',
    answer: '天狼影院采用先进的CDN加速和多线路智能切换技术，在绝大多数网络环境下均可实现流畅不缓冲的播放体验。如遇缓冲，建议检查本地网络连接，或尝试切换播放线路，一般可立即解决。',
  },
  {
    question: '剧集更新速度和来源是怎样的？',
    answer: '天狼影院拥有专业的资源采集团队，与多家内容平台保持合作，确保剧集更新速度处于行业领先水平。国产热播剧通常在电视台播出后2小时内上线，海外剧集同步更新，每日更新资源超过200部。',
  },
  {
    question: '天狼影院支持哪些设备观看？',
    answer: '天狼影院全面适配PC端、安卓手机、苹果手机、iPad及各类平板设备。支持Chrome、Safari、Edge等主流浏览器，也提供移动端APP下载。同时支持投屏到智能电视，让您在大屏幕上享受影院级观影体验。',
  },
];

export const carouselData = [
  {
    title: '暑期档爆款剧集大盘点',
    description: '今年暑期档神仙打架，多部S+级大剧轮番上线。从古装仙侠到现代都市，从悬疑推理到甜宠恋爱，总有一部适合你。',
    tag: '热门专题',
  },
  {
    title: '悬疑剧爱好者必看清单',
    description: '烧脑反转、层层递进，精选近年来口碑最佳的国产悬疑剧。每部都让你欲罢不能，一口气刷完停不下来。',
    tag: '编辑精选',
  },
  {
    title: '十部值得重温的经典国产剧',
    description: '有些剧值得一看再看。从《琅琊榜》到《甄嬛传》，这些经典作品无论何时重温，都能带来新的感动与思考。',
    tag: '经典重温',
  },
  {
    title: '韩剧迷不可错过的年度佳作',
    description: '复仇爽剧、浪漫爱情、奇幻设定——韩剧总能带来惊喜。盘点近年口碑与收视双丰收的韩剧精品。',
    tag: '海外精选',
  },
  {
    title: '古装剧服化道美学赏析',
    description: '一部好的古装剧离不开精美的服化道设计。从汉服形制到场景搭建，深度解析近年古装剧的视觉美学。',
    tag: '深度专题',
  },
  {
    title: '都市情感剧的现实主义转向',
    description: '当代都市剧越来越贴近现实生活，聚焦职场、婚恋、家庭等社会议题。这些剧集不只是娱乐，更是时代的镜像。',
    tag: '行业观察',
  },
];

export const aboutData = {
  title: '关于我们',
  paragraphs: [
    '天狼影院创立于2018年，是国内领先的免费高清影视在线观看平台。我们以"让每个人都能自由享受影视艺术"为使命，持续为亿万用户提供最新、最全、最流畅的电视剧连播服务。',
    '平台汇聚了超过五万部电视剧资源，涵盖国产剧、韩剧、美剧、日剧、泰剧、英剧等全球优质内容。无论是热播新剧还是经典老片，在这里都能找到。我们的内容团队7×24小时不间断更新，确保用户始终能第一时间观看到最新剧集。',
    '在技术层面，天狼影院投入大量资源用于播放体验优化。采用先进的H.265编码技术，在同等画质下节省50%带宽；多CDN智能调度系统，确保全国用户均能享受流畅不缓冲的观影体验。同时支持1080P高清画质，让每一帧画面都清晰动人。',
    '天狼影院坚信，优质的影视内容应当触手可及。我们将继续秉持初心，为每一位追剧爱好者提供更好的服务。',
  ],
};

export const cardsData = [
  {
    title: '长安十二时辰',
    category: '古装悬疑',
    rating: 9.2,
    description: '唐朝上元节前夕，死囚张小敬临危受命，与李必携手在十二时辰内拯救长安。易烊千玺、雷佳音主演的硬核古装悬疑大作。',
  },
  {
    title: '狂飙',
    category: '刑侦涉案',
    rating: 9.5,
    description: '一部横跨二十年的黑白较量。安欣与高启强从相识到对立，展现扫黑除恶的艰辛历程。张译、张颂文教科书级演技。',
  },
  {
    title: '去有风的地方',
    category: '田园治愈',
    rating: 8.9,
    description: '都市白领许红豆辞职来到云南大理，在有风小院遇见了一群温暖的人，重新找到生活的意义。刘亦菲、李现主演。',
  },
  {
    title: '三体',
    category: '科幻巨制',
    rating: 8.7,
    description: '根据刘慈欣同名小说改编，纳米科学家汪淼卷入神秘事件，揭开地球文明面临的外星威胁。国产科幻剧里程碑之作。',
  },
  {
    title: '苍兰诀',
    category: '仙侠言情',
    rating: 8.8,
    description: '低阶仙女小兰花意外与月尊东方青苍互换身体，一段跨越三界的甜虐交织的爱情故事。虞书欣、王鹤棣主演。',
  },
  {
    title: '漫长的季节',
    category: '悬疑生活',
    rating: 9.4,
    description: '出租车司机龚彪卷入一桩尘封多年的碎尸案，在小城桦林展开一场跨越二十年的追寻。范伟、秦昊主演，辛爽导演。',
  },
];

export const commentsData = [
  {
    author: '追剧达人小王',
    content: '天狼影院真的是我发现的宝藏平台！画质超清晰，更新速度也快，狂飙更新那会儿基本跟电视台同步。最重要的是完全免费，不用充会员，真的太良心了。推荐给身边所有追剧的朋友了！',
    rating: 5,
    date: '3天前',
  },
  {
    author: '影视爱好者小李',
    content: '作为一个每天至少看两集剧的人，天狼影院的流畅度让我非常满意。之前用其他平台经常卡顿，换到天狼之后几乎没有缓冲过。资源也很全，一些小众日剧都能找到。',
    rating: 5,
    date: '5天前',
  },
  {
    author: '上班族小张',
    content: '通勤路上用手机看剧，天狼影院的移动端体验做得很不错。界面简洁，没有乱七八糟的弹窗广告。投屏到电视上画质也很棒，周末在家追剧太享受了。希望继续保持！',
    rating: 4,
    date: '1周前',
  },
  {
    author: '学生党小陈',
    content: '宿舍网速一般，但天狼影院看剧基本不卡，这点真的很赞。剧集更新非常及时，长安十二时辰刚播完就能在这看到全集连播了。分类也很清晰，找剧很方便，推荐！',
    rating: 5,
    date: '2周前',
  },
];

export const rankingData = [
  { rank: 1, title: '狂飙', category: '刑侦涉案', heat: '9.5', trend: 'up' },
  { rank: 2, title: '漫长的季节', category: '悬疑生活', heat: '9.4', trend: 'up' },
  { rank: 3, title: '长安十二时辰', category: '古装悬疑', heat: '9.2', trend: 'stable' },
  { rank: 4, title: '去有风的地方', category: '田园治愈', heat: '8.9', trend: 'up' },
  { rank: 5, title: '苍兰诀', category: '仙侠言情', heat: '8.8', trend: 'stable' },
  { rank: 6, title: '三体', category: '科幻巨制', heat: '8.7', trend: 'down' },
];

export const indexData = [
  { title: '国产剧', description: '最新热播国产电视剧', count: '15,280部' },
  { title: '韩剧', description: '高分韩剧全集连播', count: '3,650部' },
  { title: '美剧', description: '热门美剧实时更新', count: '2,890部' },
  { title: '日剧', description: '经典日剧一键追剧', count: '1,920部' },
  { title: '泰剧', description: '泰剧爱好者聚集地', count: '980部' },
  { title: '古装剧', description: '仙侠宫斗古装大剧', count: '4,320部' },
  { title: '悬疑剧', description: '烧脑反转精彩不断', count: '2,150部' },
  { title: '爱情剧', description: '甜宠虐恋应有尽有', count: '5,680部' },
  { title: '动漫', description: '热门动漫同步更新', count: '3,450部' },
];

export const topicsData = [
  { label: '狂飙大结局', count: '128万讨论' },
  { label: '张译演技', count: '96万讨论' },
  { label: '长安十二时辰', count: '85万讨论' },
  { label: '暑期档推荐', count: '73万讨论' },
  { label: '悬疑剧天花板', count: '68万讨论' },
  { label: '治愈系好剧', count: '61万讨论' },
  { label: '古装剧服化道', count: '55万讨论' },
  { label: '三体电视剧', count: '48万讨论' },
  { label: '韩剧推荐', count: '42万讨论' },
  { label: '经典国产剧', count: '38万讨论' },
];

export const featuresData = [
  {
    icon: 'ri-movie-2-line',
    title: '海量资源',
    description: '超过五万部高清电视剧资源，涵盖全球热门剧集，每日200+内容更新，追剧永不停歇。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速流畅',
    description: '多CDN智能加速与H.265编码技术，确保全国用户均能享受不缓冲的流畅播放体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '高清画质',
    description: '全平台支持1080P高清画质，部分热门剧集提供4K超清选项，让每一帧都纤毫毕现。',
  },
  {
    icon: 'ri-device-line',
    title: '多端适配',
    description: '全面适配手机、平板、电脑及智能电视，支持投屏播放与离线缓存，随时随地畅享追剧。',
  },
];

export const updatesData = [
  { date: '2026-07-31', title: '《唐朝诡事录之西行》全集上线', description: '古装志怪探案剧全集连播已上线，会员抢先看全集。' },
  { date: '2026-07-30', title: '服务器全面升级完成', description: '平台已完成全国节点服务器升级，播放流畅度提升30%。' },
  { date: '2026-07-29', title: '暑期档专题页面上线', description: '特别策划暑期档推荐专题，精选30部高分好剧一站式追剧。' },
  { date: '2026-07-28', title: '《黑神话：山海》全集更新', description: '玄幻巨制《黑神话：山海》全40集上线，高清画质免费观看。' },
  { date: '2026-07-27', title: '移动端APP 3.0版发布', description: '新版APP支持画中画播放、倍速记忆等新功能，用户体验全面升级。' },
  { date: '2026-07-26', title: '韩剧频道内容扩充', description: '新增200+部高分韩剧资源，包括多部2026年最新季播剧集。' },
  { date: '2026-07-25', title: '播放线路智能切换上线', description: '全新智能切换系统自动选择最优线路，缓冲率降低至0.3%以下。' },
  { date: '2026-07-24', title: '《玫瑰的故事》加更', description: '应观众要求，《玫瑰的故事》每日加更一集，追剧更过瘾。' },
  { date: '2026-07-23', title: '社区互动功能上线', description: '弹幕和评论功能全面开放，和千万观众一起边看边聊。' },
];

export const contactData = {
  title: '联系我们',
  description: '如有任何问题、建议或合作意向，欢迎通过以下方式与我们联系。天狼影院团队将竭诚为您服务。',
  email: 'contact@tianlangcinema.com',
  wechat: 'TianLangCinema',
  weibo: '@天狼影院官方',
  workingHours: '客服时间：周一至周日 9:00 - 22:00',
};

export const mediaData = [
  {
    title: '《狂飙》高能名场面合集',
    duration: '15:32',
    description: '回顾《狂飙》中最令人难忘的经典名场面，高启强与安欣的巅峰对决。',
  },
  {
    title: '《长安十二时辰》幕后纪实',
    duration: '22:18',
    description: '独家探班《长安十二时辰》拍摄现场，揭秘大唐盛世的还原过程。',
  },
  {
    title: '2026暑期档新剧速览',
    duration: '08:45',
    description: '一口气看完今年暑期档即将上线的所有重磅新剧，追剧清单已备好。',
  },
  {
    title: '《漫长的季节》导演访谈',
    duration: '30:10',
    description: '辛爽导演深度对话，讲述《漫长的季节》创作背后的故事与思考。',
  },
  {
    title: '《三体》特效制作揭秘',
    duration: '18:55',
    description: '走进《三体》视效团队，看国产科幻如何突破技术天花板。',
  },
];

export const footerData = {
  description: '天狼影院 - 电视剧全集连播平台，提供最新剧集高清免费在线观看。海量资源每日更新，流畅不缓冲，随时随地畅享追剧乐趣。',
  sections: [
    {
      title: '快速导航',
      links: [
        { label: '热播推荐', href: '#cards' },
        { label: '热播榜单', href: '#ranking' },
        { label: '全站索引', href: '#index' },
        { label: '常见问题', href: '#faq' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '联系方式', href: '#contact' },
        { label: '最新动态', href: '#updates' },
        { label: '精彩片段', href: '#media' },
      ],
    },
  ],
};